export enum IrbRebalanceEvents {  
    SHOW_DELETE_SCHEDULED_DIALOG = "IRBREBALANCEEVENTS.SHOW_DELETE_SCHEDULED_DIALOG",
    SHOW_PROCESS_SCHEDULED_DIALOG = "IRBREBALANCEEVENTS.SHOW_PROCESS_SCHEDULED_DIALOG",
    SHOW_CHANGE_OWNER_SCHEDULED_DIALOG = "IRBREBALANCEEVENTS.SHOW_CHANGE_OWNER_SCHEDULED_DIALOG",
    SHOW_REFRESH_SCHEDULED_DIALOG = "IRBREBALANCEEVENTS.SHOW_REFRESH_SCHEDULED_DIALOG",
    SHOW_EDIT_COVEREDCALL_REBALANCE = "IRBREBALANCEEVENTS.SHOW_EDIT_COVEREDCALL_REBALANCE",
    SHOW_EDIT_CREATE_REBALANCE = "IRBREBALANCEEVENTS.SHOW_EDIT_CREATE_REBALANCE",
    SHOW_PORTFOLIO_RESULT_DETAIL = "IRBREBALANCEEVENTS.SHOW_PORTFOLIO_RESULT_DETAIL",
    SAVE_PORTFOLIO_RESULT_DETAIL = "IRBREBALANCEEVENTS.SAVE_PORTFOLIO_RESULT_DETAIL",
    NAVIGATE_FROM_PORTFOLIO_RESULT_DETAIL = "IRBREBALANCEEVENTS.NAVIGATE_FROM_PORTFOLIO_RESULT_DETAIL",
    SHOW_REBALANCE_RESULT_DETAIL = "IRBREBALANCEEVENTS.SHOW_REBALANCE_RESULT_DETAIL",
    SCHEDULED_REBALANCE = "IRBREBALANCEEVENTS.SCHEDULED_REBALANCE",
    SCHEDULED_REBALANCE_NOW = "IRBREBALANCEEVENTS.SCHEDULED_REBALANCE_NOW",
    MANUAL_ADJUSTMENT_REBALANCE = "IRBREBALANCEEVENTS.MANUAL_ADJUSTMENT_REBALANCE",
    SHOW_ADJUST_SECURITIES_REBALANCE = "IRBREBALANCEEVENTS.SHOW_ADJUST_SECURITIES_REBALANCE",
    SHOW_HARVEST_TAX_LOSS_REBALANCE = "IRBREBALANCEEVENTS.SHOW_HARVEST_TAX_LOSS_REBALANCE",
    SHOW_GENERATE_CASH_REBALANCE = "IRBREBALANCEEVENTS.SHOW_GENERATE_CASH_REBALANCE",
    SHOW_INVEST_CASH_REBALANCE = "IRBREBALANCEEVENTS.SHOW_INVEST_CASH_REBALANCE",
    SHOW_GENERATE_INVEST_CASH_REBALANCE = "IRBREBALANCEEVENTS.SHOW_GENERATE_INVEST_CASH_REBALANCE",
    SHOW_REPLACE_SECURITIES_REBALANCE = "IRBREBALANCEEVENTS.SHOW_REPLACE_SECURITIES_REBALANCE",
    PROCESS_SELECTION_NOW = "IRBREBALANCEEVENTS.PROCESS_SELECTION_NOW",
    SHOW_TLH_FULL_REBALANCE = "IRBREBALANCEEVENTS.SHOW_TLH_FULL_REBALANCE"
}
